import { LanguageMetadata, LanguageTranslation } from "../types";

export const bg: LanguageTranslation = {
  translation: {
    header: {
      prices: "Цени",
      courses: "Курсове",
      about: "За нас",
      testimonials: "Отзиви",
      contacts: "Контакти",
      home: "Начало",
      switchLanguage: "Смяна на език",
      closeMenu: "Затвори менюто",
    },
    footer: {
      contact_us: "Свържете ce c нас",
      working_hours: "Работно време",
      contacts: "Контакти",
      partners: "Партньори",
      get_in_touch: "Свържете ce c нас",
      follow_us: "Последвайте ни",
      navTitle: "Меню",
      privacyPolicy: "Политика за поверителност",
      cookiePolicy: "Политика за бисквитки",
      copyright: "© Всички права запазени 2026 ",
    },
    feedback: {
      not_found: {
        title: "Страницата не e намерена",
        description: "Съжаляваме, не можахме да намерим страницата, която търсите.",
        go_back: "Върнете ce обратно",
      },
    },
    cookieConsent: {
      title: "Бисквитки",
      acceptButton: "Приемам",
      declineButton: "Отказвам",
      messageLead: "Този уебсайт използва бисквитки за подобряване на вашият опит. Вижте нашата",
      messageTrail: "за повече информация.",
      privacyPolicyLink: "политика за поверителност",
    },
    legal: {
      privacy: {
        title: "Политика за поверителност",
        intro:
          "Ценим вашата поверителност и се ангажираме да бъдем прозрачни относно събираните данни и начина на използването им. Този уебсайт използва аналитика за наблюдение на представянето и подобряване на потребителското изживяване. Аналитичната услуга събира анонимни данни чрез бисквитки, за да разберем как посетителите взаимодействат със сайта.",
        anonymousIntro: "Събираните от аналитичния инструмент данни са анонимни и включват:",
        list: {
          pageViews: "Прегледи на страници и модели на навигация",
          device: "Тип устройство и информация за браузъра",
          geo: "Географско местоположение (само на ниво държава)",
          performance: "Показатели за производителността на сайта",
        },
        noPersonal:
          "Не събираме и не съхраняваме лична информация чрез аналитиката. Можете да деактивирате бисквитките от настройките на браузъра си, въпреки че това може да повлияе на част от функционалността.",
        moreInfoPrefix: "За повече информация относно практиките за поверителност, посетете",
        vercelPolicyLinkLabel: "Политика за поверителност",
      },
      cookies: {
        title: "Политика за бисквитки",
        intro:
          "Използваме бисквитки и подобни технологии, където е необходимо за функционирането на сайта и за измерване на анонимен трафик (напр. чрез аналитика). При първо посещение можете да приемете или откажете неосновни бисквитки чрез лентата за съгласие. Можете също да управлявате бисквитките през настройките на браузъра си.",
      },
    },
    contact: {
      contactTitle: "Свържете ce c нас",
      contactSubtitle: "Моля, предоставете вашите данни и ние ще ce свържем c вас скоро.",
      infoTitle: "Свържете се с нас",
      infoDescription:
        "Резервация за гмуркане, въпроси за курсове или планиране на посещение - пишете ни и ще ви отговорим възможно най-скоро.",
      phoneLabel: "Телефон",
      emailLabel: "Имейл",
      locationLabel: "Адрес",
      locationValue: "Плаж Арапя, Царево, област Бургас 8260, България",
      fullName: "Пълно име",
      email: "Имейл",
      phoneNumber: "Телефонен номер",
      subject: "Тема",
      subjectPlaceholder: "Изберете тема",
      subjectGeneral: "Общо запитване",
      subjectBooking: "Резервации и гмуркане",
      subjectCourses: "Курсове и сертификация",
      subjectOther: "Друго",
      message: "Съобщение",
      messagePlaceholder: "Напишете съобщението си тук ...",
      agreeToPolicies: "C избора на това, вие ce съгласявате c нашата <link/>",
      privacyPolicyLink: "политика за поверителност",
      privacyPolicyNote:
        "Изпращайки формата, вие се съгласявате с нашата <link>политика за поверителност</link>.",
      submitButton: "Изпрати съобщение",
      send: "Изпрати",
      sendMessage: "Изпрати ни съобщение",
      alertSuccess: "✅ Съобщението е изпратено успешно!",
      alertError: "❌ Грешка при изпращане! Моля, опитайте отново.",
      configurationError:
        "Формата за контакт не е налична в момента. Моля, обадете се или пишете на имейла на тази страница.",
    },
    contacts: {
      parallax: {
        title: "Гмуркане, обучение и общност от 1999 г.",
        subtitle: "Базата ни на плаж Арапя обединява инструктори, сертифицирани от BNAU.",
        imageAlt: "Фоново изображение на страницата за контакти",
      },
    },
    prices: {
      columns: {
        activity: "Дейност",
        course: "Курс",
        price: "Цена",
      },
      tourist: {
        title: "Еднодневно преживяване",
        tryDive: "Пробно гмуркане (включва скоростна лодка, инструктор, пълна екипировка)",
        snorkeling: "Шнорхелинг (включва скоростна лодка, инструктор, пълна екипировка)",
        passenger: "Пътник",
      },
      certified: {
        title: "Сертифицирани водолази",
        boatDive: "1 гмуркане c лодка (включва скоростна лодка, бутилки, тежести, водач)",
        twoDives: "1 ден/2 гмуркания c лодка (включва скоростна лодка, бутилки, тежести, водач)",
        nightDive: "Нощно гмуркане (включва скоростна лодка, бутилки, тежести, водач)",
        mopangWreck: "Гмуркане до потънал кораб Мопанг",
        rodinaWreck: "Гмуркане до потънал кораб Родина",
        equipmentRental: "1 ден наем на пълна екипировка",
      },
      cmas: {
        title: "Курсове",
        bubbleMaker: "CMAS Bubblemaker за деца 8-12 години",
        sealTeam: "CMAS Sealteam за деца в басейн",
        scubaDiver: "CMAS Scuba Diver (2/3 дни)",
      },
    },
    home: {
      hero: {
        eyebrow: "Скуба център Арапя · Черно море",
        title: "Гмурни се в следващото си",
        titleHighlight: "приключение",
        subtitle: "Изживей чудесата на подводния свят с обиколки и курсове за гмуркане от експерти",
        scroll: "Скрол",
      },
      services: {
        sectionEyebrow: "Подводни изживявания",
        title: "Нашите предложения",
        subtitle:
          "Първо гмуркане, с лодка или искаш да станеш сертифициран CMAS дайвър. Избери нивото си и се свържи с нас за резервация.",
        whatsIncluded: "Какво е включено:",
        learnMore: "Научете повече",
        level: {
          beginner: "За начинаещи",
          intermediate: "Средно ниво",
          recommended: "Препоръчано",
          advanced: "За напреднали",
        },
      },
      mission: {
        title: "Нашата мисия",
        description:
          "Да вдъхновим любов и уважение към живота в Черно море, като разкриваме неговата изключителна красота и уязвимост. Чрез всяко гмуркане не само предлагаме незабравимо приключение, но и повишаваме осведомеността за необходимостта от опазване на този уникален морски свят за бъдещите поколения.",
      },
      testimonials: {
        sectionEyebrow: "Отзиви от гости",
        title: "Какво казват нашите клиенти",
        subtitle: "За опита им по време на гмуркане с нас",
      },
      faq: {
        title: "Често задавани въпроси",
        questions: {
          when: {
            q: "Кога се провеждат гмурканията?",
            a: "Отваряме официално на 1 юни  и работим до 20 септември. Гмурканията се провеждат при подходящи условия и с предварително резервация. Точният график се уточнява при записване!",
          },
          experience: {
            q: "Необходимо ли е да имаш опит за да се гмурканеш?",
            a: "Не, преживяването е подходящо както за напълно начинаещи, така и за по-опитни водолази. Инструкторът ще ви осигури всичко необходимо и ще ви води през целия процес.",
          },
          whatToBring: {
            q: "Какво трябва да нося със себе си?",
            a: "Всичко, от което се нуждаете, е обичайно плажно облекло – бански, джапанки, хавлия и слънцезащитен крем. Всичко останало, включително екипировката за гмуркане, ще бъде предоставено.",
          },
          restrictions: {
            q: "Има ли възрастови и здравословни ограничения?",
            a: "Минималната възраст за гмуркане е 10 години, като за лица под 18 години е необходимо съгласие от родител/настойник. Гмуркането не е подходящо при определени медицински състояния като възпалени синуси, хрема, проблеми с тъпанчетата, високо кръвно налягане и други.",
          },
          friends: {
            q: "Мога ли да доведа приятели?",
            a: "Да! Има възможност да споделите преживяването с приятел или партньор, като максималният брой участници в едно гмуркане е двама.",
          },
        },
      },
      newsletter: {
        title: "Абонирайте се",
        subtitle:
          "Ние уважаваме вашата поверителност. Получавайте актуални новини и интересни статии директно във входящата си кутия.",
        emailPlaceholder: "Enter your email",
        subscribeButton: "Абониране",
        subscribeSuccess: "Благодарим - успешно се абонирахте.",
        subscribeError: "Нещо се обърка. Моля, опитайте отново след малко.",
        weeklyArticles: "Седмични статии",
        weeklyArticlesDesc:
          "Всяка седмица ще получавате полезни и интересни статии директно на вашия имейл.",
        noSpam: "Без спам",
        noSpamDesc:
          "Ние уважаваме вашата поверителност. Получавайте актуални новини и интересни статии директно във входящата си кутия.",
      },
    },
    about: {
      hero: {
        title: "Гмуркане, обучение и общност от 1999 г.",
        subtitle:
          "Базата ни на плаж Арапя обединява инструктори, сертифицирани от BNAU, поддържана екипировка и лодка до най-добрите места за гмуркане в Черно море.",
        bannerAlt: "Скуба дайвинг център Арапя - база и крайбрежие на плаж Арапя",
      },
      timeline: {
        1999: "Началото в гр. Китен под името Black Sea Scuba Diving School",
        2001: "Преместване в къмпинг \u201eАрапя\u201c и раждане на настоящото име",
        2004: "Официално основаване и сертификация от BNAU",
        today: "Днес",
        todayDesc: "Съвременна база, моторна лодка и над 25 години опит",
      },
      certification: {
        title: "Сертификация и Професионализъм",
        bnau: {
          title: "BNAU Сертифицирани",
          desc: "Официално признати инструктори",
        },
        modern: {
          title: "Модерни Методи",
          desc: "Качествено обучение по съвременни стандарти",
        },
        equipment: {
          title: "Съвременно Оборудване",
          desc: "Актуална и безопасна екипировка",
        },
        experience: {
          title: "25+ Години Опит",
          desc: "Доверие и професионализъм от 1999",
        },
        findUs: "Можете да ни намерите сред регистрираните инструктори",
        here: "тук",
      },
      facilities: {
        sectionTitle: "Нашите Съоръжения",
        base: {
          title: "База в Къмпинг Арапя",
          desc: "Разполагаме със собствена база, включваща оборудвана обучителна зала, басейн за подготовка, компресор за въздух и хотелска част. Центърът се намира между Царево и Лозенец - идеално място за обучение и приключения.",
          imageAlt: "База в къмпинг Арапя",
        },
        boat: {
          title: "Моторна Лодка с Капацитет 8 Водолаза",
          desc: "Разполагаме с моторна лодка и пълна екипировка, която ни позволява гъвкавост и разнообразие при избора на места за гмуркане. Нашият екип от квалифицирани инструктори гарантира професионализъм и сигурност.",
          imageAlt: "Моторната лодка на центъра",
        },
      },
      gallery: {
        title: "Галерия",
        centerPhotoAlt: "Център Арапя",
      },
    },
    services: {
      courses: {
        title: "Курсове по гмуркане",
        shortDescription: "Научете се да се гмуркате с инструктори, сертифицирани от CMAS и PADI.",
        price: "500 €",
        features: {
          cmasCourse: "Сертифициран CMAS курс за начинаещи",
          allLevels: "Курсове за всички нива",
          specialized: "Специализирани курсове",
          specializedDesc: "Включително нощно гмуркане, подводна фотография и други",
        },
        content: {
          p1: "Представете си как дишате под водата, безтегловни, докато цветен морски живот се носи покрай вас и слънчевата светлина прониква в дълбините. Това не е мечта-точно това ви очаква само след <strong>една седмица</strong>. Нашите <strong>сертифицирани CMAS и PADI инструктори</strong> са водили <strong>стотици начинаещи</strong> през този магичен момент, когато страхът се превръща в възхищение.",
          p2: "За <strong>седем дни</strong> ще овладеете всичко - от първия си вдишване през регулатор до уверено навигиране в подводния терен. Комбинираме теоретични уроци с практически сесии в басейн, преди да ви отведем в открито море. Всяко парче оборудване, всеки урок, всеки протокол за безопасност е проектиран около една цел: да ви даде <strong>уменията и увереността да изследвате безопасно</strong>, където и да ви отведе любопитството.",
          p3: "Вашият <strong>международно признат CMAS сертификат</strong> не е просто карта-това е <strong>паспорт към места за гмуркане по целия свят</strong>, от тропически рифове до исторически корабокрушения. Ще се присъедините към световна общност от водолази, които са открили, че океанът не е място за страх, а свят за изследване.",
          p4: "Готови ли сте да се потопите? <strong>Свържете се с нас днес</strong>, за да резервирате място и да получите подробна информация за предстоящите дати на курсовете, цени и какво да донесете. Тук сме, за да отговорим на всички ваши въпроси и да ви помогнем да започнете подводното си пътешествие. Океанът ви чака-нека се потопим заедно.",
        },
      },
      dayDive: {
        title: "Дневно гмуркане",
        shortDescription: "Започнете своето приключение с еднодневна подводна разходка!",
        price: "60 €",
        features: {
          guides: "Опитни водачи по гмуркане",
          equipment: "Бутилки, тежести и екипировка",
        },
        content: {
          p1: "Започнете своето приключение с еднодневна подводна разходка! Това е перфектната възможност за <strong>напълно начинаещи</strong> да научат основите на гмуркането. <strong>Не се нуждаете от опит</strong> за да пробвате!",
          p2: "Отнема около <strong>два часа и половина (2.5 часа)</strong> като е специално подготвено за абослютно начинаещи. Ще ви покажем техниките за дишане и основните движения под водата.",
          p3: "По време на гмуркане ще се докоснете в подводния свят, под ръководството на <strong>опитните ни инструктори</strong>, които ще ви осигурят <strong>безопасност и увереност</strong> през цялото време. Гмуркате се с него!",
          p4: "Гмуркането е чудесен начин да откриете магията на подводния свят. Звъннете ни <strong>(+359 898 839 357)</strong>, за да резервирате вашето място и да започнете своето гмуркане днес!",
        },
      },
      boatDive: {
        title: "Гмуркане с лодка",
        shortDescription: "Гмуркане извън залива, само за сертифицирани водолази.",
        price: "100 €",
        features: {
          wreckDive: "Гмуркане с лодка до потънал кораб",
          certifiedOnly: "Само за сертифицирани водолази",
        },
        content: {
          p1: "Изживейте вълнуващо гмуркане до останки от кораби, ексклузивно за сертифицирани гмуркачи. Нашата лодка ще ви отведе до някои от най-интересните подводни места в района като например <strong>до потъналия кораб Жак Фресине</strong>",
          p2: "Този кораб е товарен параход потънал през 1929 г. на дълбочина от около 25 м. Гмуркайте с нашите сертифицирани CMAS инструктори като локацията може да бъде предварително дискутирана. Минимум двама гмуркачи са необходими за да се осъществи гмуркането с лодка.",
          p3: "Гмуркането с лодка ви предоставя уникална възможност да изследвате подводните чудеса на дълбочина, достъпни само чрез плаване. Очаквайте безопасно и професионално гмуркане в най-красивите подводни местности на региона. Моля да се свържете с нас, за да резервирате вашето място и да научите повече за предстоящите дати и цени. <strong> +359 898 839 357</strong>",
          p4: "Очаквайте безопасно и професионално гмуркане в най-красивите подводни местности на региона. Моля да се свържете с нас, за да резервирате вашето място и да научите повече за предстоящите дати и цени.",
        },
      },
      advancedCourse: {
        title: "За напреднали",
        shortDescription: "Технически курс за напреднали водолази.",
        price: "500 €",
        features: {
          certifiedOnly: "Само за сертифицирани водолази",
          navigation: "Умения за подводно ориентиране",
          navigationDesc: "Включва навигация с компас и по природни ориентири",
        },
        content: {
          p1: "Разширете своите гмуркачески умения с нашия курс за напреднали! Този курс е предназначен за сертифицирани водолази, които искат да подобрят техниките си и да научат нови подводни стратегии.",
          p2: "С напредналия курс ще се запознаете с техники за гмуркане в различни условия, като например дълбочинни гмуркания и гмуркания в текущи води. Ще научите и как да използвате по-специализирано оборудване.",
          p3: "Ще имате възможност да изпълнявате по-сложни маневри и да се запознаете с аварийни процедури, които ще ви подготвят за всякакви ситуации, които може да срещнете под водата.",
          p4: "Курсът ще се проведе в разнообразни подводни локации, които ще ви осигурят нови предизвикателства и възможности да демонстрирате напредналите си умения.",
        },
      },
    },
    courses: {
      seo: {
        title: "CMAS курсове по гмуркане - Скуба дайвинг център Арапя",
        description:
          "Професионални CMAS курсове по гмуркане на плаж Арапя. От начално до напреднало ниво с инструктори, сертифицирани от BNAU. Международно признати сертификати.",
      },
      hero: {
        title: "CMAS курсове по гмуркане",
        subtitle: "Професионално обучение с международно признати сертификати за всички нива",
        bannerAlt: "CMAS курсове по гмуркане в Скуба дайвинг център Арапя",
      },
    },
    seo: {
      defaultTitle: "Скуба дайвинг център Арапя",
      defaultDescription:
        "Скуба дайвинг център Арапя – водолазно гмуркане в Черно море, България. Open Water Diver курсове, SSI сертификация, гмуркане до потънали кораби, джет и плуване край Арапя и Поморие.",
      defaultKeywords:
        "scuba diving bulgaria, black sea scuba diving Bulgaria, best places to scuba dive, скуба дайвинг, водолазно гмуркане, гмуркане в България, подводни спортове, Black sea diving, wreck diving, diving courses bulgaria, open water diver курс, SSI, Арапя, Поморие, плуване, джет, регулатор за гмуркане",
      aboutTitle: "За нас - Скуба дайвинг център Арапя",
      aboutDescription:
        "Научете повече за центъра ни на плаж Арапя: инструктори, сертифицирани от BNAU, база за обучение, гмуркане с лодка и над 25 години край българското Черноморие.",
    },
    testimonials: {
      data: {
        1: {
          name: "Габриела Димитрова",
          handle: "@gabi",
          content:
            "Изживяването с Diving Center Arapya беше незабравимо! Изключителни професионалисти, които те карат да се чувстваш уверен и спокоен през цялото време.",
          date: "10:12 AM · Авг 19, 2024",
        },
        2: {
          name: "Антония Ангелова",
          handle: "@toniq",
          content:
            "Уникално преживяване! Препоръчвам с две ръце! Инструкторът беше страхотен, с чувство за хумор и обясняваше всичко с много внимание.",
          date: "3:25 PM · Юли 11, 2024",
        },
        3: {
          name: "Александър Ганчев",
          handle: "@sasho_first",
          content:
            "Беше ми за първи път и получих специално внимание. Инструкторката Анастасия беше изключително търпелива и грижовна. Препоръчвам!",
          date: "11:47 AM · Сеп 2, 2024",
        },
        4: {
          name: "Калина Евтимова",
          handle: "@kalina",
          content:
            "Страхотно преживяване! Аз и приятелката ми се гмуркахме за първи път и това ще остане спомен за цял живот.",
          date: "2:01 PM · Юни 15, 2024",
        },
        5: {
          name: "Цветан Вълков",
          handle: "@tsetsos",
          content:
            "Уникално изживяване и незабравим спомен. Синът ми на 10 години вече чака с нетърпение следващото лято. Благодаря за емоцията!",
          date: "9:40 AM · Авг 5, 2024",
        },
        6: {
          name: "Донелия Ангелова",
          handle: "@doneliya",
          content:
            "Невероятна емоция, страхотно място, страхотни професионалисти! Това трябва да се изживее!",
          date: "4:18 PM · Май 28, 2024",
        },
      },
    },
    priceData: {
      tourist: {
        divingWithVideo:
          "Пробно гмуркане с подводно видео (скоростна лодка, инструктор, пълна екипировка)",
      },
      certified: {
        deepDive: "1 гмуркане с лодка (скоростна лодка, бутилки, тежести, водач)",
        nightDive: "Нощно гмуркане (скоростна лодка, бутилки, тежести, водач)",
        wreckDive: "Гмуркане до потънал кораб – Мопанг или Родина",
        equipmentRental: "Наем на пълна екипировка",
      },
      cmas: {
        oneStar: "CMAS Една звезда (P1)",
        twoStar: "CMAS Две звезди (P2)",
        threeStar: "CMAS Три звезди (P3)",
      },
    },
    pricesPage: {
      currency: "€",
      pageTitle: "Ценоразпис на гмуркания и курсове",
      optionalExtra: "По желание / допълнение",
      forBeginners: "За начинаещи",
      cmasCoursesTitle: "За курсовете по системата CMAS",
      cmasIntro:
        "Официални нива по CMAS - във всяка карта има линк към пълната програма на федерацията.",
      cmasFullName:
        "Confédération Mondiale des Activités Subaquatiques (World Underwater Federation)",
      viewDetails: "Вижте детайли за курса",
      certificationCardsTitle: "Вашата CMAS сертификационна карта",
      certificationCardsDescription:
        "След успешното завършване на курса ще получите международно призната CMAS сертификационна карта. Тази карта е вашият паспорт към места за гмуркане по целия свят и се приема от дайвинг центрове в цял свят.",
      certificationCardsAlt: "Примери за CMAS сертификационни карти за всички нива",
      p1: {
        title: "P1 – Водолаз с една звезда",
        description:
          "Вашият портал към подводния свят. Този всеобхватен 7-дневен курс комбинира теоретични уроци, сесии в басейн и гмуркания в открито море. Перфектен за начинаещи-не е необходим предишен опит.",
        features: {
          depth: "Гмуркане до 20м дълбочина",
          skills: "Контрол на плавучестта, навигация, почистване на маската, аварийни процедури",
          certificate: "Международно признат CMAS* сертификат",
          duration: "7 дни: теория, гмуркания в басейн и открито море",
        },
        learnMore: "Научи повече за CMAS* (One Star Diver)",
      },
      p2: {
        title: "P2 – Водолаз с две звезди",
        description:
          "Разширете вашите гмуркачески хоризонти. Напреднало обучение в дълбочинно гмуркане, нощно гмуркане и предизвикателни условия. Изисква P1 сертификат и минимум 20 регистрирани гмуркания.",
        features: {
          depth: "Гмуркане до 30м дълбочина при различни условия",
          skills: "Дълбочинно гмуркане, нощно гмуркане, напреднала навигация и спасителни техники",
          certificate: "Международно признат CMAS** сертификат",
          duration: "5-7 дни с напреднала теория и специализирани гмуркания",
        },
        learnMore: "Научи повече за CMAS** (Two Star Diver)",
      },
      p3: {
        title: "P3 – Водолаз с три звезди",
        description:
          "Станете водач на водолази. Професионално обучение в групово лидерство, планиране на гмуркания, координация на спасителни операции и поддръжка на оборудване. Стъпка към инструкторска сертификация.",
        features: {
          leadership: "Водене и надзор на групи водолази безопасно",
          navigation: "Напреднала ориентация, планиране и реакция при извънредни ситуации",
          certificate: "Международно признат CMAS*** професионален сертификат",
          duration: "Интензивно обучение с лидерски и спасителни сценарии",
        },
        learnMore: "Научи повече за CMAS*** (Three Star Diver)",
      },
    },
  },
};

export const bgMetadata: LanguageMetadata = {
  name: "Български",
  code: "bg",
};
